import React, { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Typography,
  Divider,
  Breadcrumbs,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import DataAdminGrid from "../../components/dataAdminGrid/DataAdminGrid";
import DataGridInfoAlert from "../../components/dataAdminGrid/InfoAlert";
import { ROUTES } from "../../constants";
import {
  WELL_REG_BASE_URL,
  COLUMNS,
  WELL_REG_PK_FIELD,
} from "./wellRegistrationsConfig";
import { useWellRegistrationLookups } from "./useWellRegistrationLookups";
import AutocompleteEditCell from "../../components/dataAdminGrid/AutocompleteEditCell";

function WellRegistrationPage() {
  const { contacts, wells } = useWellRegistrationLookups();

  const columns = useMemo(() => {
    return COLUMNS.map((col) => {
      if (col.field === "contact_ndx") {
        return {
          ...col,
          renderCell: ({ value }) => {
            const found = contacts.find((c) => c.contact_ndx === value);
            return found ? (
              found.contact_name
            ) : (
              <Typography
                sx={{
                  fontStyle: "italic",
                  color: "text.secondary",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                No Contact Selected
              </Typography>
            );
          },
          renderEditCell: (params) => (
            <AutocompleteEditCell
              {...params}
              options={contacts}
              optionIdField="contact_ndx"
              optionLabelField="contact_ndx"
              multiple={false}
              label="Contact"
            />
          ),
        };
      }

      if (col.field === "well_ndx") {
        return {
          ...col,
          renderCell: ({ value }) => {
            const found = wells.find((w) => w.well_ndx === value);
            return found ? (
              found.well_ndx
            ) : (
              <Typography
                sx={{
                  fontStyle: "italic",
                  color: "text.secondary",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                No Well Selected
              </Typography>
            );
          },
          renderEditCell: (params) => (
            <AutocompleteEditCell
              {...params}
              options={wells}
              optionIdField="well_ndx"
              optionLabelField="well_ndx"
              multiple={false}
              label="Well"
            />
          ),
        };
      }

      return col;
    });
  }, [contacts, wells]);

  return (
    <Box>
      <Helmet title="Archived Well Registrations Management" />
      <Typography variant="h3" gutterBottom display="inline">
        Archived Well Registrations Management
      </Typography>

      <Breadcrumbs sx={{ mt: 4 }} aria-label="breadcrumb">
        <MuiLink component={RouterLink} to={ROUTES.LANDING}>
          Home
        </MuiLink>
        <Typography>Archived Well Registrations</Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 6 }} />
      <DataGridInfoAlert title="Manage well registration records:" />

      <DataAdminGrid
        baseUrl={WELL_REG_BASE_URL}
        columns={columns}
        primaryKeyField={WELL_REG_PK_FIELD}
        allowAdd={false}
        allowEdit={false}
        allowDelete={false}
      />
    </Box>
  );
}

export default WellRegistrationPage;
